import { createApp } from 'vue'
import { crashPlugin } from '@madxnl/dodo-ui'
import { createPinia } from 'pinia'
import { hotJarPlugin } from './hotjar'
import { router } from './router'
import { sentryPlugin } from './sentry'
import { extensionPlugin } from './extension'
import App from './app/App.vue'
import './style.css'
import '@madxnl/dodo-ui/dist/style.css'
import './variables.css'
import { i18n } from './i18n'

window.location.href.includes('socialdatabase.com') ? document.body.classList.add('h-full') : undefined

const pinia = createPinia()
const app = createApp(App)

app.directive('y-fade', {
  mounted(el, binding) {
    const fadeAmount = binding.value ?? 12
    let isScrollable
    let isScrolledToBottom
    let isScrolledToTop

    function onScroll() {
      isScrollable = el.scrollHeight > el.clientHeight

      if (!isScrollable) {
        el.classList.remove(`is-bottom-overflowing-${fadeAmount}`, `is-top-overflowing-${fadeAmount}`)
        return
      }

      isScrolledToBottom = el.scrollHeight < el.clientHeight + el.scrollTop + 1
      isScrolledToTop = isScrolledToBottom ? false : el.scrollTop === 0
      el.classList.toggle(`is-bottom-overflowing-${fadeAmount}`, !isScrolledToBottom)
      el.classList.toggle(`is-top-overflowing-${fadeAmount}`, !isScrolledToTop)
    }

    setInterval(onScroll, 100)

    el.addEventListener('scroll', onScroll)
  },
})

app.directive('col', {
  mounted(el, binding) {
    let isExpanded = false
    el.classList.add('cursor-pointer')

    let targetElement
    if (binding.value?.querySelector) {
      const querySelector = binding.value.querySelector
      targetElement = document.querySelector(querySelector)
    } else {
      targetElement = el
    }
    const targetClass = binding.value?.span ?? 'col-span-2'

    const clickHandler = () => {
      if (binding.value?.expanded !== undefined) {
        isExpanded = binding.value.expanded
      }
      isExpanded = !isExpanded
      targetElement.classList.toggle(targetClass, isExpanded)

      if (isExpanded) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'center' })
        targetElement.classList.add('relative')
        const poweredBy = document.createElement('div')
        poweredBy.id = 'poweredBy'
        poweredBy.innerHTML =
          '<div class="absolute top-20 -translate-y-1 left-8 text-sm text-gray-400 dark:text-gray-500">Powered by Socialdatabase</div>'
        targetElement.prepend(poweredBy)
        if (binding.value) {
          binding.value.expanded = true
        }
      } else {
        targetElement.classList.remove('relative')
        targetElement.querySelector('#poweredBy')?.remove()
        if (binding.value) {
          binding.value.expanded = false
        }
      }
    }

    el.addEventListener('click', clickHandler)

    el._clickHandler = clickHandler
  },
  beforeUnmount(el) {
    if (el._clickHandler) {
      el.removeEventListener('click', el._clickHandler)
      delete el._clickHandler
    }
  },
})

app.directive('attention-grabbing', {
  mounted(el) {
    const isInViewport = (element: HTMLElement) => {
      const rect = element.getBoundingClientRect()
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      )
    }

    if (!isInViewport(el)) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
    }
  },
})

app.use(i18n)
app.use(router)
app.use(sentryPlugin)
app.use(extensionPlugin)
app.use(hotJarPlugin)
app.use(pinia)
app.use(crashPlugin({ router }))

app.mount('#app')
